import React from 'react';
import { Layout } from './src/components/layout';
import { GatsbyProviders } from './src/components/gatsby-providers';
import { DisableNavigationProvider } from '@shapeable/ui';
import './src/global.css';

window.global = window

export const wrapPageElement = ({ element, props }) => {
  const disableNavigation = props.pageContext.disableNavigation || false;
  return (
    <DisableNavigationProvider value={disableNavigation}>
    <GatsbyProviders {...props}>
    <Layout {...props} disableNavigation={disableNavigation}>
      {element}
    </Layout>
    </GatsbyProviders>
    </DisableNavigationProvider>
  )
};

